<template>
  <div>
    <v-container v-if="loading">
      <v-row justify="space-around">
        <v-progress-circular
          :size="70"
          :width="7"
          color="purple"
          indeterminate
        ></v-progress-circular>
      </v-row>
    </v-container>
    <v-container v-else>
      <v-row v-if="trackList.length == 0" justify="space-around">
        <v-container>
          <v-card>
            <v-card-text class="black--text title text-center">
              No Tracking Found. <br />
              or <br />
              Tracking Code were wrong.
            </v-card-text>
          </v-card>
        </v-container>
      </v-row>
      <v-row v-else no-gutters>
        <v-col
          v-for="track in trackList"
          :key="track.itemId"
          class="pa-2"
          cols="4"
        >
          <v-card>
            <v-card-title class="pb-0">
              Item Name : {{ track.itemName }}
            </v-card-title>
            <v-card-text class="pt-0">
              <div class="font-weight-medium black--text">
                Customer : {{ track.customerName }}
              </div>
              <div class="font-weight-medium black--text">
                Onlineshopping Name : {{ track.osName }}
              </div>
              <div class="font-weight-medium black--text">
                From : {{ track.fromTownship }}
              </div>
              <div class="font-weight-medium black--text">
                To : {{ track.toTownship }}
              </div>
              <div class="font-weight-bold mt-2">Tracking Status</div>
              <v-timeline dense>
                <v-timeline-item
                  v-for="message in track.tracking"
                  :key="message.time"
                  :color="
                    message.status == 'Collected'
                      ? 'deep-purple lighten-1'
                      : message.status == 'Delivered'
                      ? 'green'
                      : message.status == 'Assigned'
                      ? 'accent'
                      : message.status == 'Return'
                      ? 'error'
                      : message.status == 'Completed'
                      ? 'green'
                      : 'red'
                  "
                  :icon="
                    message.status == 'Collected'
                      ? 'move_to_inbox'
                      : message.status == 'Delivered'
                      ? 'done_outline'
                      : message.status == 'Assigned'
                      ? 'local_shipping'
                      : message.status == 'Return'
                      ? 'no_transfer'
                      : message.status == 'Completed'
                      ? 'assignment_turned_in'
                      : 'warning'
                  "
                  fill-dot
                >
                  <div class="font-weight-normal">
                    <strong>{{
                      message.status == "Collected"
                        ? "Collected from onlineshop"
                        : message.status == "Delivered"
                        ? "Delivered to customer"
                        : message.status == "Assigned"
                        ? "Being Delivered"
                        : message.status == "Return"
                        ? "Item have been return"
                        : message.status == "Completed"
                        ? "Completed"
                        : "Error"
                    }}</strong
                    ><br />
                    {{ message.status == "Completed" ? "" : "at " }}
                    {{
                      message.status == "Completed"
                        ? ""
                        : message.date | dateTracking
                    }}
                  </div>
                </v-timeline-item>
              </v-timeline>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import trackingService from "../service/TrackingService";

export default {
  mounted: function () {
    this.hideToolbar(true);
    let trackingCode = this.$route.query.trackingCode;
    console.log("Tracking " + trackingCode);
    if (trackingCode == undefined || trackingCode == null) {
      return;
    }

    this.getTrackingData(trackingCode);
  },
  props: {
    hideToolbar: Function,
  },
  data() {
    return {
      trackList: [],
      loading: true,
    };
  },
  methods: {
    getTrackingData: function (trackingCode) {
      trackingService.getTrackingData(trackingCode).then((response) => {
        this.trackList.splice(0, this.trackList.length);
        this.trackList.push(...response);
        this.loading = false;
      });
    },
  },
};
</script>
<style scoped>
.v-timeline {
  padding-top: 10px !important;
}
.v-timeline-item {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
}
</style>